module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/am665-a48ab3cc3a13f1e6d47b6d02299ae20c.jpg";